import { api, get, post } from '@/lib/api';

const RAIZ = '/csi';

export type CsiSourceType = 'SLA_BREACH' | 'INCIDENT_REVIEW' | 'PIR' | 'PROBLEM_CLOSED' | 'SURVEY' | 'MANUAL';
export type CsiStatus = 'OPEN' | 'IN_PROGRESS' | 'CLOSED' | 'REJECTED';
export type CsiPriority = 'HIGH' | 'MEDIUM' | 'LOW';

export interface CsiImprovement {
  id: string;
  title: string;
  description: string;
  sourceType: CsiSourceType;
  sourceId: string | null;
  status: CsiStatus;
  priority: CsiPriority;
  ownerId: string | null;
  dueAt: string | null;
  closedAt: string | null;
  closureNote: string | null;
  createdById: string;
  createdAt: string;
  updatedAt: string;
}

export interface CsiPage {
  items: CsiImprovement[];
  total: number;
  page: number;
  pageSize: number;
}

export interface CreateCsiDto {
  title: string;
  description?: string;
  sourceType?: CsiSourceType;
  sourceId?: string;
  priority?: CsiPriority;
  dueAt?: string;
}

export interface UpdateCsiDto {
  title?: string;
  description?: string;
  status?: CsiStatus;
  priority?: CsiPriority;
  ownerId?: string | null;
  dueAt?: string | null;
  closureNote?: string;
}

export function listarMelhorias(params?: { status?: CsiStatus; page?: number }): Promise<CsiPage> {
  const q = new URLSearchParams();
  if (params?.status) q.set('status', params.status);
  if (params?.page) q.set('page', String(params.page));
  const qs = q.toString();
  return get<CsiPage>(`${RAIZ}${qs ? `?${qs}` : ''}`);
}

export function criarMelhoria(dto: CreateCsiDto): Promise<CsiImprovement> {
  return post<CsiImprovement>(RAIZ, dto);
}

export function atualizarMelhoria(id: string, dto: UpdateCsiDto): Promise<CsiImprovement> {
  return api<CsiImprovement>(`${RAIZ}/${id}`, { method: 'PATCH', body: dto });
}

export function excluirMelhoria(id: string): Promise<void> {
  return api<void>(`${RAIZ}/${id}`, { method: 'DELETE' });
}

export const chavesCsi = {
  lista: (status?: CsiStatus) => ['csi', 'lista', status] as const,
};
